

export interface LinecheckBasicPropConfigSchema {
    baseURL:string |'';
}
export class LinecheckBasicPropConfig {
    private static instance:LinecheckBasicPropConfig;
    
    config:LinecheckBasicPropConfigSchema ={
        baseURL: ""
    };

    private constructor(p_config:LinecheckBasicPropConfigSchema){
        this.config = p_config;
    }
    getConfig = () => {
        return this.config;
    }

    getBaseUrl = () =>{
        return this.config?.baseURL?? '';
    }

    public static getInstance = ():LinecheckBasicPropConfig => {
        return LinecheckBasicPropConfig.instance;
    }
    public static create = (p_config:LinecheckBasicPropConfigSchema):void =>{
        LinecheckBasicPropConfig.instance = new LinecheckBasicPropConfig(p_config);
    }
}
